const scripts = /[\p{Script=Latin}\p{Script=Han}\p{Script=Thai}\p{Script=Lao}\p{Script=Khmer}]/u;
const letter = /\p{L}/u;
const letterOrMark = /[\p{L}\p{M}]/u;
const accent = /[\u0300-\u036f]/u;
const segmenter = typeof Intl.Segmenter === 'function' ? new Intl.Segmenter(undefined, { granularity: 'grapheme' }) : null;
export function validateRegistrationUsername(value) {
  if (typeof value !== 'string' || !value) return false;
  const chars = [...value];
  const length = segmenter ? [...segmenter.segment(value)].length : chars.filter(c => !/\p{M}/u.test(c)).length;
  if (length < 4 || length > 32 || chars.length > 128 || new TextEncoder().encode(value).length > 512) return false;
  if (!(letter.test(chars[0]) && scripts.test(chars[0])) && !/^[0-9]$/.test(chars[0])) return false;
  if (/[_.-]{2}/.test(value) || /[\uff00-\uffef\u034f\u17b4\u17b5]/u.test(value)) return false;
  return chars.every((c, index) => {
    if (/\p{M}/u.test(c) && (index === 0 || !letterOrMark.test(chars[index - 1]))) return false;
    return /^[0-9_.-]$/.test(c) || accent.test(c) || (letterOrMark.test(c) && scripts.test(c));
  });
}
